























































































import { Component, Vue } from "vue-property-decorator";
import { LayoutPlugin } from "bootstrap-vue";
Vue.use(LayoutPlugin);
@Component({})
export default class HomeArticle extends Vue {
  // export default==protected class
}
